export interface MailReminder {
  id: string;
  updatedOn: string;
  tenant_id: number;
  strategy: number;
  emailTo: string[];
  emailCc: string[];
  emailBcc: string[];
  emailSubject: string;
  emailBody: string;
  contentHandle: string;
  firstSentNotBefore: string;
  lastSentNotAfter: string | null;
  lastSentAt: string | null;
  backoffLevel: number;
  active: boolean;
  nextSendNotBefore: string;
  emailReplyTo: string;
  emailBodyGenerationPrompt: string | null;
  lastSentEmailId: string | null;
  previousBodies: string[];
}

export enum MailReminderActive {
    INACTIVE = 0,
    ACTIVE = 1
}

export enum MailReminderStrategy {
    DAILY = 0,
    WEEKLY = 1,
    EXP_BACKOFF_DAILY_POW_2 = 2,
    BI_DAILY = 3
}